import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import SidebarMenu from './sidebar-menu';
import { useMediaQuery } from 'react-responsive';

const drawerWidth = 240;

const useStyles = makeStyles((theme) =>
  createStyles({
    drawer: {
      [theme.breakpoints.up('sm')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    drawerPaper: {
      width: drawerWidth,
    },
  })
);

type SidebarProps = {
  mobileOpened?: boolean;
  onClose?: () => void;
};

export const Sidebar: React.FC<SidebarProps> = ({ mobileOpened, onClose }: SidebarProps) => {
  const classes = useStyles();
  const container = window.document.body;
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 480px)' });

  return (
    <nav className={classes.drawer}>
      <Hidden smUp implementation="css">
        <Drawer
          container={container}
          variant="temporary"
          anchor="left"
          open={mobileOpened}
          onClose={onClose}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {isTabletOrMobile && <SidebarMenu onChange={onClose as any} />}
        </Drawer>
      </Hidden>
      <Hidden xsDown implementation="css">
        <Drawer
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
        >
          {!isTabletOrMobile && <SidebarMenu onChange={() => {}} />}
        </Drawer>
      </Hidden>
    </nav>
  );
};

export default Sidebar;
